import script from "./AddUserBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUserBar.vue?vue&type=script&setup=true&lang=js"

import "./AddUserBar.vue?vue&type=style&index=0&id=494e0a22&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-494e0a22"]])

export default __exports__